/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AddUpdateJobModal_job$ref = any;
type DeleteJobModal_job$ref = any;
type UserAvatar_user$ref = any;
export type JobStateStatus = "COMPLETE" | "INCOMPLETE" | "IN_PROGRESS" | "NEEDS_ATTENTION" | "PAUSED";
export type JobStatus = "CLOSED" | "OPEN";
export type WorkflowStateType = "JOB_COMPLETED" | "JOB_CREATED" | "JOB_ITEM_COUNT" | "RUN" | "TASK";
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobsTable_jobEdges$ref: FragmentReference;
declare export opaque type JobsTable_jobEdges$fragmentType: JobsTable_jobEdges$ref;
export type JobsTable_jobEdges = $ReadOnlyArray<{|
  +node: {|
    +id: string,
    +jobNumber: string,
    +importJobNumber: ?string,
    +name: string,
    +status: JobStatus,
    +createdAt: any,
    +user: ?{|
      +id: string,
      +$fragmentRefs: UserAvatar_user$ref,
    |},
    +yields: {|
      +totalCount: number
    |},
    +order: ?{|
      +id: string,
      +promisedAt: ?any,
      +customer: {|
        +id: string,
        +name: string,
      |},
    |},
    +states: $ReadOnlyArray<{|
      +id: string,
      +isEnabled: boolean,
      +status: JobStateStatus,
      +workflowState: {|
        +id: string,
        +name: string,
        +type: ?WorkflowStateType,
      |},
    |}>,
    +workflow: {|
      +id: string,
      +states: $ReadOnlyArray<{|
        +id: string,
        +name: string,
        +isRequired: ?boolean,
        +type: ?WorkflowStateType,
      |}>,
      +transitions: $ReadOnlyArray<{|
        +id: string,
        +toWorkflowState: {|
          +id: string
        |},
        +fromWorkflowState: {|
          +id: string
        |},
      |}>,
    |},
    +$fragmentRefs: AddUpdateJobModal_job$ref & DeleteJobModal_job$ref,
  |},
  +$refType: JobsTable_jobEdges$ref,
|}>;
export type JobsTable_jobEdges$data = JobsTable_jobEdges;
export type JobsTable_jobEdges$key = {
  +$data?: JobsTable_jobEdges$data,
  +$fragmentRefs: JobsTable_jobEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v4 = [
  (v0/*: any*/)
];
return {
  "kind": "Fragment",
  "name": "JobsTable_jobEdges",
  "type": "JobEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Job",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "jobNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "importJobNumber",
          "args": null,
          "storageKey": null
        },
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "createdAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "UserAvatar_user",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "yields",
          "storageKey": null,
          "args": null,
          "concreteType": "JobYieldConnection",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "totalCount",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "order",
          "storageKey": null,
          "args": null,
          "concreteType": "Order",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "promisedAt",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "customer",
              "storageKey": null,
              "args": null,
              "concreteType": "Customer",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "states",
          "storageKey": null,
          "args": null,
          "concreteType": "JobState",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isEnabled",
              "args": null,
              "storageKey": null
            },
            (v2/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "workflowState",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkflowState",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v3/*: any*/)
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "workflow",
          "storageKey": null,
          "args": null,
          "concreteType": "Workflow",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "states",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkflowState",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isRequired",
                  "args": null,
                  "storageKey": null
                },
                (v3/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "transitions",
              "storageKey": null,
              "args": null,
              "concreteType": "WorkflowTransition",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "toWorkflowState",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "WorkflowState",
                  "plural": false,
                  "selections": (v4/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "fromWorkflowState",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "WorkflowState",
                  "plural": false,
                  "selections": (v4/*: any*/)
                }
              ]
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "AddUpdateJobModal_job",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "DeleteJobModal_job",
          "args": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '1b3b3b98bc7cc4b65fbca0519fb49d59';
module.exports = node;
